import { Spinner, Text, InlineStack } from '@shopify/polaris';

const LoadingSpinner = ({ statusText, size }) => {
  return(
    <div role="status">
      <InlineStack gap="200" blockAlign="center">
        <Spinner size={size || 'small'} accessibilityLabel={statusText || 'Loading'} />
        <Text as="span">{ statusText || 'Loading Preview' }</Text>
      </InlineStack>
    </div>
  )
}

export default LoadingSpinner;
